export class FilterWithholdingGroup{
    description!: string;
}